export const EP = 1
export const ASSINATURA_SUPORTE = 2
export const ACOMPANHAMENTO_BASICO = 116
export const ACOMPANHAMENTO_ESSENCIAL = 117
export const ACOMPANHAMENTO_ELITE = 118
export const GESTAO_FINANCEIRA = 222
export const APP_MEU_FUTURO_MENSAL = 274
export const APP_MEU_FUTURO_ANUAL = 275
export const SUPORTE_OPEN = 276
export const ACOMPANHAMENTO_BASICO_OPEN = 277
export const ACOMPANHAMENTO_ESSENCIAL_OPEN = 278
export const ACOMPANHAMENTO_ELITE_OPEN = 279
export const ACOMPANHAMENTO_PREMIUM = 304
export const ACCOMPANHAMENTO_OFF_FUTURO = 305

export const isAssinatura = (financial_solution_id) => {
    return (
        financial_solution_id == ASSINATURA_SUPORTE ||
        financial_solution_id == ACOMPANHAMENTO_BASICO ||
        financial_solution_id == ACOMPANHAMENTO_ESSENCIAL ||
        financial_solution_id == ACOMPANHAMENTO_ELITE || 
        financial_solution_id == GESTAO_FINANCEIRA || 
        financial_solution_id == SUPORTE_OPEN ||
        financial_solution_id == ACOMPANHAMENTO_BASICO_OPEN ||
        financial_solution_id == ACOMPANHAMENTO_ESSENCIAL_OPEN ||
        financial_solution_id == ACOMPANHAMENTO_ELITE_OPEN  || 
        financial_solution_id == APP_MEU_FUTURO_MENSAL ||
        financial_solution_id == APP_MEU_FUTURO_ANUAL || 
        financial_solution_id == ACOMPANHAMENTO_PREMIUM ||
        financial_solution_id == ACCOMPANHAMENTO_OFF_FUTURO
    );
}